import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import products from "../Products/data";
import services from "../Services/data";

function Footer() {
    return (
        <footer className="footer">
            <div className="container mt-5" style={{paddingLeft:"50px"}}>
                <div className="row">
                    {/* Contact Information */}
                    <div className="col-md-3">
                        <h5>Contact Us</h5>
                        <a className="tel" href="tel:000:000:00" >
                            <i style={{ color: "#00A5E7", fontSize: "16px" }} className="fas fa-phone-alt p-2"></i>
                            <span>Call Us: 000:000:0000</span>
                        </a>
                        <p>
                            <i style={{fontSize:"16px" , color: "#00A5E7"}} className="fas fa-clock p-2"></i>
                            <span>Sun-Thu 8:00a-5:00p</span>
                        </p>
                        <div className="social-icon" >
                            <a href="#" className="social-link p-2">
                                <i style={{fontSize:"26px" , color: "#fff"}} className="fab fa-facebook-f"></i>
                            </a>
                            <a href="#" className="social-link p-2">
                                <i style={{fontSize:"26px" , color: "#fff"}} className="fab fa-linkedin-in"></i>
                            </a>
                            <a href="#" className="social-link p-2">
                                <i style={{fontSize:"26px" , color: "#fff"}} className="fab fa-instagram"></i>
                            </a>
                            <a href="#" className="social-link p-2">
                                <i style={{fontSize:"26px" , color: "#fff"}} className="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>
                    {/* Security Products */}
                    <div className="col-md-3">
                        <h5>Security Products</h5>
                        <ul className="list-unstyled">
                            {products.map((product, index) => (
                                <li key={index}>
                                    <Link to={`/product/${index}`}>{product.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Security Services */}
                    <div className="col-md-3">
                        <h5>Security Services</h5>
                        <ul className="list-unstyled">
                            {services.map((service, index) => (
                                <li key={index}>
                                    <Link to={`/service/${index}`}>{service.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Other Links */}
                    <div className="col-md-3">
                        <h5>Quick Links</h5>
                        <ul className="list-unstyled">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">About Us</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contact Us</Link>
                            </li>
                            <li>
                                <Link to="/privacy-policy">Privacy Policy</Link>
                            </li>
                            <li>
                                <Link to="/careers">Careers</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className="text-center mt-3">
                    © All Rights Reserved 2024 | Berimbolo Security
                </p>
            </div>
        </footer>
    );
}

export default Footer;
